// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-6fe2e281!./~/less-loader?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app-nav.vue
// module id = 1152
// module chunks = 129